export enum ProcessoArquivoSituacaoEnum {
  PENDENTE = 'PENDENTE',
  ASSINADO = 'ASSINADO',
  ASSINANDO = 'ASSINANDO',
  REJEITADO = 'REJEITADO'
}
